import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useAlbumsPhotos from "./hooks/useAlbumsPhotos";

import AlbumDetails from "./components/AlbumDetails";
import AlbumDrawer from "./components/AlbumDrawer";
import AlbumForm from "./components/AlbumForm";
import AlbumsGrid from "./components/AlbumsGrid";
import AlbumsHero from "./components/AlbumsHero";
import AlbumsStats from "./components/AlbumsStats";
import AlbumsToolbar from "./components/AlbumsToolbar";
import PhotosManager from "./components/PhotosManager";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function AlbumsPhotos() {
  useScrollToTop();
  const {
    loading,
    saving,
    photoSaving,
    filters,
    setFilter,
    albums,
    filteredAlbums,
    selectedAlbum,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useAlbumsPhotos();

  return (
    <div className="space-y-6">
      <AlbumsHero
        loading={loading}
        total={albums.length}
        activeCount={stats.active}
        photosCount={stats.photos}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshGalleries}
      />

      <AlbumsStats loading={loading} stats={stats} />

      <AlbumsToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={albums.length}
        filteredCount={filteredAlbums.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshGalleries}
      />

      <AlbumsGrid
        loading={loading}
        albums={filteredAlbums}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onManagePhotos={actions.openPhotosDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
      />

      <AlbumDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        album={selectedAlbum}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedAlbum && (
          <AlbumDetails
            album={selectedAlbum}
            onEdit={() => actions.openEditDrawer(selectedAlbum)}
            onManagePhotos={() => actions.openPhotosDrawer(selectedAlbum)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <AlbumForm
            mode="create"
            saving={saving}
            onSubmit={actions.createAlbum}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedAlbum && (
          <AlbumForm
            mode="edit"
            album={selectedAlbum}
            saving={saving}
            onSubmit={actions.updateAlbum}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "photos" && selectedAlbum && (
          <PhotosManager
            album={selectedAlbum}
            saving={photoSaving}
            onAddPhoto={actions.addPhotoToAlbum}
            onDeletePhoto={actions.deletePhotoFromAlbum}
            onClose={actions.closeDrawer}
          />
        )}
      </AlbumDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}